"use client";

import React from "react";
import { MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
const serviceAreas = [{
  name: "Maryland",
  path: "/ServiceAreasPage"
}, {
  name: "Northern Virginia",
  path: "/ServiceAreasPage"
}, {
  name: "Montgomery County",
  path: "/ServiceAreasPage"
}, {
  name: "Arlington, VA",
  path: "/ServiceAreasPage"
}, {
  name: "Fairfax, VA",
  path: "/ServiceAreasPage"
}, {
  name: "Frederick, MD",
  path: "/ServiceAreasPage"
}, {
  name: "Bethesda, MD",
  path: "/ServiceAreasPage"
}, {
  name: "Rockville, MD",
  path: "/ServiceAreasPage"
}];
export default function ServiceAreas() {
  return <section data-section-id="255550" id="service-areas" className="py-24 bg-background text-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {}
          <div className="relative rounded-lg overflow-hidden shadow-lg bg-muted border border-border">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/maryland_virginia_service_map.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/maryland_virginia_service_map.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660464/img/maryland_virginia_service_map.png-wvc-sizes" alt="Map of Eagle Exteriors service coverage in Maryland and Northern Virginia" className="w-full h-auto object-cover opacity-100 hover:opacity-95 transition-opacity duration-500" loading="lazy" />
          </div>

          {}
          <div>
            <h2 className="text-3xl md:text-[32px] font-default font-bold text-primary mb-6">
              Proudly Serving Local Homeowners
            </h2>
            <p className="text-muted-foreground mb-10 text-lg font-default leading-relaxed">
              Eagle Exteriors provides expert roofing, siding, and gutter solutions across the DMV area. Our local teams are ready to protect your home with quality craftsmanship.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {serviceAreas.map((area, i) => <Link key={i} to={area.path} data-index={i} className="group flex items-center gap-3 px-5 py-4 rounded-md border border-border bg-card text-foreground hover:border-secondary hover:bg-secondary/5 transition-all duration-300 shadow-sm">
                  <MapPin className="w-5 h-5 shrink-0 text-secondary group-hover:scale-110 transition-transform duration-300" />
                  <span className="font-default font-medium group-hover:text-primary transition-colors duration-300">
                    {area.name}
                  </span>
                </Link>)}
            </div>
          </div>

        </div>
      </div>
    </section>;
}